'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dNext$002dError$002dObserver from "./com.raquo.airstream.common.-Internal-Next-Error-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dEvent$002dStream from "./com.raquo.airstream.core.-Event-Stream.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream from "./com.raquo.airstream.core.-Writable-Stream.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream from "./com.raquo.airstream.distinct.-Distinct-Stream.js";
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBusStream(parentDisplayName) {
  this.E6 = null;
  this.E5 = false;
  this.E7 = null;
  this.E3 = null;
  this.E4 = null;
  this.Ea = false;
  this.E8 = null;
  this.uN = null;
  this.E9 = 0;
  this.E8 = parentDisplayName;
  this.E6 = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.uN = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_com$002eraquo$002eairstream$002ecore$002e$002dEvent$002dStream.$d_Lcom_raquo_airstream_core_EventStream.r().C)([])));
  this.E9 = 1;
}
export { $c_Lcom_raquo_airstream_eventbus_EventBusStream as $c_Lcom_raquo_airstream_eventbus_EventBusStream };
$p = $c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_EventBusStream;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBusStream() {
}
export { $h_Lcom_raquo_airstream_eventbus_EventBusStream as $h_Lcom_raquo_airstream_eventbus_EventBusStream };
$h_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = $p;
$p.dP = (function() {
  return this.E6;
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.E5;
});
$p.fm = (function() {
  return this.E7;
});
$p.ea = (function(x$1) {
  this.E5 = x$1;
});
$p.gD = (function(x$1) {
  this.E7 = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.hm = (function(observer) {
});
$p.ew = (function() {
  return this.E3;
});
$p.ey = (function() {
  return this.E4;
});
$p.hw = (function() {
  return this.Ea;
});
$p.g1 = (function(x$1) {
  this.Ea = x$1;
});
$p.hf = (function(x$0) {
  this.E3 = x$0;
});
$p.hg = (function(x$0) {
  this.E4 = x$0;
});
$p.fX = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dNext$002dError$002dObserver.$f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.dT = (function() {
  return this.E9;
});
$p.fW = (function(nextValue, ignoredTransaction) {
  new $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
  })));
});
$p.fV = (function(nextError, transaction) {
  new $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$c_Lcom_raquo_airstream_core_Transaction(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
  })));
});
$p.hp = (function() {
  var arr = this.uN;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(arr[i]);
    i = ((1 + i) | 0);
  }
});
$p.hn = (function() {
  var arr = this.uN;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(arr[i], this, false);
    i = ((1 + i) | 0);
  }
});
$p.ho = (function() {
  var arr = this.uN;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(arr[i], this);
    i = ((1 + i) | 0);
  }
});
$p.dd = (function() {
  return (this.E8.h() + ".events");
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_eventbus_EventBusStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_eventbus_EventBusStream, "com.raquo.airstream.eventbus.EventBusStream", ({
  gX: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  ba: 1,
  bm: 1,
  as: 1,
  bI: 1,
  aj: 1,
  cL: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_EventBusStream as $d_Lcom_raquo_airstream_eventbus_EventBusStream };
